<template>
  <div class="goods_index">
    <el-breadcrumb separator="/" slot="breadcrumb" class="breadcrumb-bg">
      <el-breadcrumb-item>首页</el-breadcrumb-item>
      <el-breadcrumb-item>我的明细</el-breadcrumb-item>
    </el-breadcrumb>

    <el-table
      :data="tableData.data"
      stripe
      style="width: 100%; margin-top: 10px"
      @selection-change="handleSelectionChange"
      ref="multipleTable"
    >
      <el-table-column prop="oid" label="订单号"> </el-table-column>

      <el-table-column prop="money" label="消费金额">
        <template slot-scope="scope">
            {{ scope.row.symbol }} {{ scope.row.money }}
        </template>
      </el-table-column>
      <el-table-column prop="money" label="余额">
        <template slot-scope="scope">
          {{ scope.row.balance }}
        </template>
      </el-table-column>

      <el-table-column prop="buyer_name" label="下单人">
        <template slot-scope="scope">
          {{ scope.row.buyer_name }}
        </template>
      </el-table-column>
      <el-table-column prop="buyer_name" label="描述">
        <template slot-scope="scope">
          {{ scope.row.content }}
        </template>
      </el-table-column>
      <el-table-column prop="level" label="创建日期">
        <template slot-scope="scope">
          {{ formatGMT(scope.row.created_time) }}
        </template>
      </el-table-column>
    </el-table>
    <div class="header-top-15">
      <el-card class="box-card">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="tableData.totalpages"
          @current-change="changePage"
        >
        </el-pagination>
      </el-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      formInline: {
        oid: "",
        status: 0,
      },

      page: 1,
    };
  },
  methods: {
    ...mapActions({
      getPaymentDataAction: "getPaymentDataAction",
    }),
    formatGMT(gmt, long) {
      long = false === long ? false : true;
      let date = new Date(gmt);

      let m = date.getMonth() + 1,
        mm = "-" + (m < 10 ? "0" + m : m);
      let d = date.getDate(),
        dd = "-" + (d < 10 ? "0" + d : d);
      let h = date.getHours(),
        hh = " " + (h < 10 ? "0" + h : h);
      let i = date.getMinutes(),
        ii = ":" + (i < 10 ? "0" + i : i);
      let s = date.getSeconds(),
        ss = ":" + (s < 10 ? "0" + s : s);

      return date.getFullYear() + mm + dd + (long ? hh + ii + ss : "");
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    changePage(e) {
      this.page = e;
      this.changePageData(e);
    },
    changePageData(page) {
      this.page = page;

      this.getPaymentDataAction({ page: page });
    },
    getPageData() {
      if (this.oid != "") {
        this.getPaymentDataAction({
          page: this.page,
        });
      } else {
        this.getPaymentDataAction({
          page: this.page,

          status: this.status,
        });
      }
    },
  },

  mounted() {
    this.getPageData();
  },
  //tableData
  computed: mapState({
    tableData: (state) => state.payment.result,
  }),
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.dialog-footer {
  text-align: center;
  background-color: gainsboro;
  padding: 0.3rem;
}
</style>
